/**
 * SEO 配置 - models (العربية)
 */

export default {
    veo_3_1: {
        title: 'Google Veo 3.1 - مولد فيديو الذكاء الاصطناعي الرائد | WeryAI',
        description: 'Google Veo 3.1: نموذج فيديو الذكاء الاصطناعي الرائد مع صوت أصلي والتحكم في الإطارات.',
        keywords: 'Google Veo 3.1, فيديو الذكاء الاصطناعي, مولد فيديو, WeryAI',
    },
    veo_3: {
        title: 'Google Veo 3 - توليد فيديو الذكاء الاصطناعي عالي الجودة | WeryAI',
        description: 'جرب Veo 3 على WeryAI. نتائج عالية الجودة.',
        keywords: 'Veo 3, Google Veo, فيديو الذكاء الاصطناعي, WeryAI',
    },
    veo_3_fast: {
        title: 'Google Veo 3 Fast - توليد فيديو الذكاء الاصطناعي فائق السرعة | WeryAI',
        description: 'جرب Veo 3 Fast على WeryAI. نتائج عالية الجودة وسريعة.',
        keywords: 'Veo 3 Fast, فيديو الذكاء الاصطناعي السريع, WeryAI',
    },
    sora_2: {
        title: 'OpenAI Sora 2 - مولد فيديو الذكاء الاصطناعي الواقعي | WeryAI',
        description: 'جرب Sora 2 على WeryAI. نتائج عالية الجودة.',
        keywords: 'Sora 2, OpenAI Sora, فيديو الذكاء الاصطناعي, WeryAI',
    },
    weryai_video_1: {
        title: 'WeryAI Video 1.0 - مولد فيديو الذكاء الاصطناعي | WeryAI',
        description: 'جرب WeryAI Video 1.0 لإنشاء فيديوهات سينمائية بالذكاء الاصطناعي.',
        keywords: 'WeryAI Video 1.0, فيديو الذكاء الاصطناعي, WeryAI',
    },
    weryai_image_2: {
        title: 'WeryAI Image 2.0 - مولد صور الذكاء الاصطناعي | WeryAI',
        description: 'جرب WeryAI Image 2.0 لتوليد صور بجودة استوديو.',
        keywords: 'WeryAI Image 2.0, صور الذكاء الاصطناعي, WeryAI',
    },
    image_grok_2: {
        title: 'Grok-2 مولد الصور - xAI | WeryAI',
        description: 'جرب Grok-2 من xAI على WeryAI.',
        keywords: 'Grok-2, xAI, صور الذكاء الاصطناعي, WeryAI',
    },
    kling_ai: {
        title: 'Kling AI - مولد فيديو الذكاء الاصطناعي السينمائي | WeryAI',
        description: 'جرب Kling AI على WeryAI. نتائج عالية الجودة.',
        keywords: 'Kling AI, فيديو الذكاء الاصطناعي, WeryAI',
    },
    runway_ai: {
        title: 'Runway AI - مولد ومحرر فيديو الذكاء الاصطناعي | WeryAI',
        description: 'جرب Runway AI على WeryAI. نتائج عالية الجودة.',
        keywords: 'Runway AI, فيديو الذكاء الاصطناعي, WeryAI',
    },
    hailuo_23: {
        title: 'Hailuo 2.3 - مولد فيديو الذكاء الاصطناعي | WeryAI',
        description: 'جرب Hailuo 2.3 على WeryAI. نتائج عالية الجودة.',
        keywords: 'Hailuo 2.3, فيديو الذكاء الاصطناعي, WeryAI',
    },
    hailuo_ai: {
        title: 'Hailuo AI - مولد فيديو الذكاء الاصطناعي المتقدم | WeryAI',
        description: 'جرب Hailuo AI على WeryAI. نتائج عالية الجودة.',
        keywords: 'Hailuo AI, فيديو الذكاء الاصطناعي, WeryAI',
    },
    pika_2_2: {
        title: 'Pika 2.2 - مولد رسوم متحركة الذكاء الاصطناعي | WeryAI',
        description: 'جرب Pika 2.2 على WeryAI. نتائج عالية الجودة.',
        keywords: 'Pika 2.2, رسوم متحركة الذكاء الاصطناعي, WeryAI',
    },
    seedance: {
        title: 'Seedance - مولد فيديو الرقص والحركة بالذكاء الاصطناعي | WeryAI',
        description: 'جرب Seedance على WeryAI. نتائج واقعية واحترافية.',
        keywords: 'Seedance, فيديو الذكاء الاصطناعي, WeryAI',
    },
    wan_ai: '',
    image_nano_banana_pro: {
        title: 'Nano Banana Pro - توليد صور Google Gemini 3.0 Pro | WeryAI',
        description: 'نموذج صور الذكاء الاصطناعي القائم على التفكير. جودة 4K فائقة الواقعية وتنسيق نص مثالي.',
        keywords: 'Nano Banana Pro, Gemini 3.0 Pro, توليد صور الذكاء الاصطناعي, WeryAI',
    },
    image_nano_banana: {
        title: 'Google Nano Banana - رسم فائق السرعة Gemini 2.5 Flash | WeryAI',
        description: 'مولد صور الذكاء الاصطناعي فائق السرعة من Google DeepMind. يدعم التحرير باللغة الطبيعية.',
        keywords: 'Nano Banana, Gemini 2.5 Flash, رسم سريع, WeryAI',
    },
    image_flux: {
        title: 'FLUX AI مولد الصور - نموذج مفتوح المصدر | WeryAI',
        description: 'FLUX طوره فريق Stable Diffusion الأصلي. جودة بصرية استثنائية.',
        keywords: 'FLUX, الذكاء الاصطناعي, توليد الصور, WeryAI',
    },
    image_flux_kontext: {
        title: 'FLUX.1 Kontext - تحسين الرسم الاحترافي بالذكاء الاصطناعي | WeryAI',
        description: 'FLUX.1 Pro و Max مع عرض نص محسن واتساق الشخصيات.',
        keywords: 'FLUX Kontext, FLUX Pro, FLUX Max, WeryAI',
    },
    image_imagen: {
        title: 'Google Imagen 4 - نموذج انتشار النص إلى صورة | WeryAI',
        description: 'أنشئ صورًا واقعية وفنية ومجردة باستخدام Google Imagen 4.',
        keywords: 'Imagen 4, Google AI, انتشار, WeryAI',
    },
    image_qwen_image: {
        title: 'Qwen Image - نموذج عرض النص من Alibaba | WeryAI',
        description: 'نموذج صور الذكاء الاصطناعي من Alibaba لعرض النص متعدد اللغات.',
        keywords: 'Qwen Image, Alibaba, عرض النص, WeryAI',
    },
    image_wan_ai: {
        title: 'Wan 2.5 توليد الصور - نموذج عالي الدقة من Alibaba | WeryAI',
        description: 'Wan 2.5 مع تتبع دقيق للتعليمات وعرض فوتوغرافي.',
        keywords: 'Wan AI, Wan 2.5, توليد الصور, WeryAI',
    },
    image_seendream: {
        title: 'Seedream 4.0 - نموذج الرسم 4K من ByteDance | WeryAI',
        description: 'نموذج رسم فائق السرعة من ByteDance مع معالجة دفعية.',
        keywords: 'Seedream, ByteDance, رسم 4K, WeryAI',
    },
    image_dreamina: {
        title: 'Dreamina 4.0 - نموذج إنشاء صور الذكاء الاصطناعي من ByteDance | WeryAI',
        description: 'Dreamina 4.0 لتحويل الرسم إلى صورة ونقل الأنماط.',
        keywords: 'Dreamina 4.0, ByteDance, إنشاء صور الذكاء الاصطناعي, WeryAI',
    },
    image_seedream_4_5: {
        title: 'Seedream 4.5 - نموذج توليد صور الذكاء الاصطناعي الرائد من ByteDance | WeryAI',
        description: 'Seedream 4.5 هو أحدث نموذج صور الذكاء الاصطناعي الرائد من ByteDance، يركز على عرض الطباعة الدقيق ودمج الصور المتعددة مع إخراج 4K فائق الوضوح. جربه مجانًا على WeryAI.',
        keywords: 'Seedream 4.5, توليد صور الذكاء الاصطناعي, عرض الطباعة, دمج الصور, ByteDance, جودة 4K, WeryAI',
    },
    image_midjourney: {
        title: 'Midjourney - توليد صور مرن ومفصل ونابض بالحياة | WeryAI',
        description: 'Midjourney هو نموذج صور بالذكاء الاصطناعي رائد من مختبر أبحاث مستقل، يشتهر بجمالياته الفنية. جربه مجانًا على WeryAI.',
        keywords: 'Midjourney, توليد صور بالذكاء الاصطناعي, إبداع فني, جودة الإضاءة, عرض النص, صور شخصية واقعية, WeryAI',
    },
    runway_4_5: {
        title: 'Runway Gen-4.5 مولد فيديو الذكاء الاصطناعي - إنشاء فيديوهات سينمائية | WeryAI',
        description: 'أنشئ فيديوهات مذهلة مع Runway Gen-4.5 على WeryAI. معمارية هجينة انتشارية ذاتية الانحدار لمحاكاة فيزيائية دقيقة واتساق زمني.',
        keywords: 'Runway Gen-4.5, مولد فيديو الذكاء الاصطناعي, فيديو سينمائي بالذكاء الاصطناعي, محاكاة فيزيائية, Runway AI, WeryAI',
    },
    kling_2_6_pro: {
        title: 'Kling 2.6 Pro مولد فيديو الذكاء الاصطناعي - إنشاء فيديو عالي الجودة | WeryAI',
        description: 'أنشئ فيديوهات عالية الجودة مع Kling 2.6 Pro على WeryAI. توليد سمعي بصري أصلي، جودة سينمائية 1080p، التزام ممتاز بالنصوص.',
        keywords: 'Kling 2.6 Pro, مولد فيديو الذكاء الاصطناعي, فيديو عالي الجودة بالذكاء الاصطناعي, Kling AI, WeryAI',
    },
    video_dreamina_3: {
        title: 'Dreamina 3.0 مولد فيديو - تحكم دقيق بالكاميرا وتوجيه الإطارات | WeryAI',
        description: 'أنشئ فيديوهات سينمائية بالذكاء الاصطناعي مع Dreamina 3.0 (Jimeng 3.0) على WeryAI. تحكم دقيق بإطارات البداية/النهاية، حركات كاميرا احترافية وتوليد فيديو 1080p عالي الديناميكية.',
        keywords: 'Dreamina 3.0, Jimeng Video 3.0, مولد فيديو الذكاء الاصطناعي, تحكم الكاميرا, إطارات البداية النهاية, ByteDance AI, WeryAI',
    },
    kling_o1: {
        title: 'Kling O1 مولد فيديو الذكاء الاصطناعي - توليد فيديو إبداعي | WeryAI',
        description: 'أطلق إبداعك على WeryAI مع مولد فيديو الذكاء الاصطناعي Kling O1. مثالي لإنشاء محتوى فيديو خيالي وفريد.',
        keywords: 'Kling O1, مولد فيديو الذكاء الاصطناعي, فيديو إبداعي بالذكاء الاصطناعي, Kling AI, WeryAI',
    },
}
